import { useContext } from 'react';
import { Context } from './context';
export default function useLaravelReactI18n() {
    return useContext(Context);
}
